import { render, staticRenderFns } from "./UserMessagesIndex.vue?vue&type=template&id=6fa37736&scoped=true&"
import script from "./UserMessagesIndex.vue?vue&type=script&lang=js&"
export * from "./UserMessagesIndex.vue?vue&type=script&lang=js&"
import style0 from "./UserMessagesIndex.vue?vue&type=style&index=0&id=6fa37736&scoped=true&lang=scss&"
import style1 from "./UserMessagesIndex.vue?vue&type=style&index=1&id=6fa37736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa37736",
  null
  
)

export default component.exports